(() => {
  document.querySelectorAll('[data-nursery-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-nursery-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-nursery-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-nursery-dot]'));
    const toggle = carousel.querySelector('[data-nursery-next]');
    const firstVideo = carousel.querySelector('[data-primary-nursery-video]');
    let activeIndex = 0;

    if (!track || slides.length < 2 || !toggle) return;

    const showSlide = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = `translateX(-${activeIndex * 100}%)`;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
        if (slideIndex !== activeIndex) slide.querySelector('video')?.pause();
      });

      const showingSecond = activeIndex === slides.length - 1;
      toggle.textContent = '>';
      toggle.setAttribute('aria-label', showingSecond ? 'Return to the first nursery video' : 'See the second nursery video');
    };

    toggle.addEventListener('click', () => showSlide(activeIndex === 0 ? 1 : 0));
    firstVideo?.addEventListener('ended', () => showSlide(1));
    showSlide(0);
  });
})();
